import axios from "axios"

class Search {
  // 1. describe and create/initiate our object
  constructor() {
    this.addSearchHTML()
    this.resultatsDiv = document.querySelector("#search-overlay__resultats")
    this.openButton = document.querySelectorAll(".js-search-trigger")
    this.closeButton = document.querySelector(".search-overlay__close")
    this.searchOverlay = document.querySelector(".search-overlay")
    this.searchField = document.querySelector("#search-term")
    this.isOverlayOpen = false
    this.isSpinnerVisible = false
    this.previousValue
    this.typingTimer
    this.evenements()
  }

  // 2. evenements
  evenements() {
    this.openButton.forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault()
        this.openOverlay()
      })
    })

    this.closeButton.addEventListener("click", () => this.closeOverlay())
    document.addEventListener("keydown", (e) => this.keyPressDispatcher(e))
    this.searchField.addEventListener("keyup", () => this.typingLogic())
  }

  // 3. methods (function, action...)
  typingLogic() {
    if (this.searchField.value != this.previousValue) {
      clearTimeout(this.typingTimer)

      if (this.searchField.value) {
        if (!this.isSpinnerVisible) {
          this.resultatsDiv.innerHTML = '<div class="spinner-loader"></div>'
          this.isSpinnerVisible = true
        }
        this.typingTimer = setTimeout(this.getresultats.bind(this), 750)
      } else {
        this.resultatsDiv.innerHTML = ""
        this.isSpinnerVisible = false
      }
    }

    this.previousValue = this.searchField.value
  }

  async getresultats() {
    try {
      const response = await axios.get(siteAssoDonnee.urlRacine + "/wp-json/siteAsso_/v1/recherche?cle=" + this.searchField.value)
      const resultats = response.data
      this.resultatsDiv.innerHTML = `
        <div class="separe-plein">
          <div class="separe-plein__un">
            <h2 class="search-overlay__section-title">Informations générales</h2>
            ${resultats.infoGen.length ? '<ul class="link-list min-list">' : "<p>Aucune information générale pour cette recherche.</p>"}
              ${resultats.infoGen.map((item) => `<li><a href="${item.lienUrl}">${item.title}</a></li>`).join("")}
            ${resultats.infoGen.length ? "</ul>" : ""}

            <!-- Les associés -->
            <h2 class="search-overlay__section-title">Associés</h2>
            ${resultats.associes.length ? '<ul class="associe-cartes">' : `<p>Aucun associé pour cette recherche.</p>`}
              ${resultats.associes
                .map(
                  (item) => `
                <li class="associe-carte__list-item">
                  <a class="associe-carte" href="${item.lienUrl}">
                    <img class="associe-carte__image" src="${item.photo}">
                    <span class="associe-carte__name">${item.title}</span>
                  </a>
                </li>
              `
                )
                .join("")}
            ${resultats.associes.length ? "</ul>" : ""}

          </div>

          <div class="separe-plein__un">
            <h2 class="search-overlay__section-title">Activités</h2>
            ${resultats.activites.length ? "" : `<p>Aucune activité pour cette recherche. <a href="${siteAssoDonnee.urlRacine}/activites">Voir les activités.</a></p>`}
              ${resultats.activites
                .map(
                  (item) => `
                <div class="sommaire-activite">
                  <a class="sommaire-activite__date t-center" href="${item.lienUrl}">
                    <span class="sommaire-activite__month">${item.mois}</span>
                    <span class="sommaire-activite__day">${item.jour}</span>  
                  </a>
                  <div class="sommaire-activite__content">
                    <h5 class="sommaire-activite__title headline headline--tiny"><a href="${item.lienUrl}">${item.title}</a></h5>
                    <p>${item.description} <a href="${item.lienUrl}" class="nu c-lien">Apprenez-en plus...</a></p>
                  </div>
                </div>
              `
                )
                .join("")}

                <!-- Les comités -->
                <h2 class="search-overlay__section-title">Comités</h2>
                ${resultats.comites.length ? '<ul class="link-list min-list">' : "<p>Aucun comité pour cette recherche.</p>"}
                  ${resultats.comites.map((item) => `<li><a href="${item.lienUrl}">${item.title}</a></li>`).join("")}
                ${resultats.comites.length ? "</ul>" : ""}
    
              </div>
        </div>
      `
      this.isSpinnerVisible = false
    } catch (e) {
      console.log(e)
    }
  }

  keyPressDispatcher(e) {
    if (e.keyCode == 83 && !this.isOverlayOpen && document.activeElement.tagName != "INPUT" && document.activeElement.tagName != "TEXTAREA") {
      this.openOverlay()
    }

    if (e.keyCode == 27 && this.isOverlayOpen) {
      this.closeOverlay()
    }
  }

  openOverlay() {
    this.searchOverlay.classList.add("search-overlay--active")
    document.body.classList.add("body-no-scroll")
    this.searchField.value = ""
    setTimeout(() => this.searchField.focus(), 301)
    console.log("Notre methode (Open) vient de s'exécuter !")
    this.isOverlayOpen = true
    return false
  }

  closeOverlay() {
    this.searchOverlay.classList.remove("search-overlay--active")
    document.body.classList.remove("body-no-scroll")
    console.log("Notre methode (Close) vient de s'exécuter !")
    this.isOverlayOpen = false
  }

  addSearchHTML() {
    document.body.insertAdjacentHTML(
      "beforeend",
      `
      <div class="search-overlay">
        <div class="search-overlay__top">
          <div class="container">
            <i class="fa fa-search search-overlay__icon" aria-hidden="true"></i>
            <input type="text" class="search-term" placeholder="Que recherchez-vous ?" id="search-term">
            <i class="fa fa-window-close search-overlay__close" aria-hidden="true"></i>
          </div>
        </div>
        
        <div class="container">
          <div id="search-overlay__resultats"></div>
        </div>

      </div>
    `
    )
  }
}

export default Search
